export default "__VITE_ASSET__BgdAEyEb__"